module.exports = __webpack_public_path__ + "static/media/ci.02796bef.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ci.svg
// module id = 793
// module chunks = 0